import { AIRY_PRODUCT_CARD } from '@/previewThemes/imageSlots';
import type { ThemeMeta, ThemeTokens } from '@/previewThemes/meta';

export const tokens: ThemeTokens = {
  headingFont: 'Playfair Display',
  accent: null,
  monoFont: null,
  headingTracking: '0.01em',
  headingTransform: 'none',
  containerMax: '80rem',
  spaceScale: 1.35,
  headerHeight: '5rem',
};

export const meta: ThemeMeta = {
  label: 'Editorial',
  hint: 'Serif headings and generous space, like a magazine.',
  industries: ['fashion_apparel', 'home_kitchen', 'furniture', 'books_stationery', 'flowers_gifts'],
  look: {
    // Ink on warm paper. The primary is close enough to the text colour to
    // read as a rule rather than a button, which is the magazine's voice.
    colors: {
      primary: '#1c1c1a',
      background: '#fbfaf7',
      surface: '#f1efe9',
      text: '#1c1c1a',
      muted: '#77736b',
    },
    typography: {
      font_family: 'Inter',
      heading_font: 'Playfair Display',
      heading_weight: '600',
    },
    buttons: { radius_px: 0, style: 'outline' },
    catalog: 'home',
  },
  // `listing.card` and `search.card` are `airy` in `theme.tsx`, which
  // ProductCard draws `aspect-[3/4]`; the product page's gallery is `portrait`
  // (4:5). See `imageSlots.ts`.
  imageSpecs: { PRODUCT: AIRY_PRODUCT_CARD },
};
